'use client';

import React from 'react';
import { TabsPath } from 'components/commercetools-ui/organisms/account/types/types';
import CuratedSlider, { Props as CuratedSliderProps } from 'components/commercetools-ui/organisms/curated-slider';
import { useCheckPathAndHash } from 'components/commercetools-ui/organisms/utils';
import { usePersonalizedCartBanner } from 'frontastic/hooks';
import { TasticProps } from '../types';

const CuratedSliderTastic = ({ data }: TasticProps<CuratedSliderProps>) => {
  const shouldDisplayThisTastic = useCheckPathAndHash('/account', TabsPath.MY_ACCOUNT);
  const { data: personalizedCartBannerData } = usePersonalizedCartBanner({
    enabled: !shouldDisplayThisTastic,
  });

  if (!shouldDisplayThisTastic) {
    return null;
  }
  return <CuratedSlider {...data} personalizedCartBannerData={personalizedCartBannerData} />;
};

export default CuratedSliderTastic;
